import React, { ReactElement, ReactNode, useEffect, useRef } from 'react';

import { css } from '@emotion/react';

import { useOnClickOutside } from '@hooks/useOnClickOutside';

import { palette } from '@styles/theme';

interface Props {
    open: boolean;
    handleOpen: () => void;
    width?: number;
    height?: number;
    position?: any;
    children: ReactNode | ReactElement;
}

const Layer = ({
    open,
    handleOpen,
    width,
    height,
    position,
    children,
}: Props) => {
    const ref = useRef(null);

    const layerStyle = css({
        width: `${width ? `${width}px` : 'auto'}`,
        height: `${height ? `${height}px` : 'auto'}`,
        backgroundColor: `${palette.white}`,
        borderRadius: '10px',
        // border: `${isBorder ? `1px solid ${palette.gray3}` : 'none'}`,
        boxShadow: '0px 5px 16px rgba(0, 0, 0, 0.08)',
    });

    /** 레이어 외부 클릭시 닫힘처리 */
    useOnClickOutside(ref, () => handleOpen());

    /** ESC키 누르면 닫힘처리 */
    useEffect(() => {
        const escKeyPress = (e: any) => {
            if (e.key === 'Escape') handleOpen();
        };
        window.addEventListener('keydown', escKeyPress);
        return () => window.removeEventListener('keydown', escKeyPress);
    }, []);

    return (
        <div css={[container(position), open && openModal]}>
            <div css={layerStyle} ref={ref}>
                {children}
            </div>
        </div>
    );
};

export default Layer;

const container = (position: any) => css`
    display: none;
    position: absolute;
    z-index: 800;
    ${position && position};

    @keyframes modal-bg-show {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const openModal = css`
    display: flex;
    align-items: center;
    justify-content: center;
    animation: modal-bg-show 0.3s;
`;
